export const questions = {
    citizenship: [
        {
            id: 1,
            label: "Yes, I am a US Citizen or Permanent Resident (Green Card holder).",
            value: "Yes, I am a US Citizen or Permanent Resident (Green Card holder).",
        },
        {
            id: 2,
            label: "I am on a non-immigrant visa.",
            value: "I am on a non-immigrant visa.",
        },
        {
            id: 3,
            label: "Other Nationality.",
            value: "Other Nationality.",
        },
    ],
    service: [
        {
            id: 1,
            label: "American Citizens Services (Green Card, Permanent Residency, Citizenship, etc.)",
            value: "American Citizens Services (Green Card, Permanent Residency, Citizenship, etc.)",
            message: "I need help to apply, or renew one of these forms.",
        },
        {
            id: 2,
            label: "Immigrant Services (Family Petition, K-1 Fiancé visa, other forms for immigrant visas)",
            value: "Immigrant Services (Family Petition, K-1 Fiancé visa, other forms for immigrant visas)",
            message: "Great! Let’s gather more details about your status.",
        },
        {
            id: 3,
            label: "Non-Immigrant Services (Work Visas, Study Visas, Tourist Visas, etc.)",
            value: "Non-Immigrant Services (Work Visas, Study Visas, Tourist Visas, etc.)",
            message: "Great! Let’s gather more details about your visa status.",
        },
    ],
    userInfo: [
        {
            id: 1,
            label: "Name",
            name: "name",
            value: "Name",
            type: "text",
        },
        {
            id: 2,
            label: "Email",
            name: "email",
            value: "Email",
            type: "email",
        },
        {
            id: 3,
            label: "Phone Number",
            name: "phoneNumber",
            value: "Phone Number",
            type: "tel",
        },
        {
            id: 4,
            label: "Address",
            name: "address",
            value: "Address",
            type: "text",
        },
    ],
    final: [
        {
            id: 1,
            label: "I would like to request a call",
            value: "I would like to request a call",
        },
        {
            id: 2,
            label: "I would like to schedule a consultation",
            value: "I would like to schedule a consultation",
        },
    ]
};
